import styled from 'styled-components'
import { Text } from "../../atoms/text";

export const StyledImageContainer = styled.div`
  text-align: center;
  margin-bottom: 50px;
`;

export const StyledTitle = styled(Text)`
  font-size: 22px;
  margin-bottom: 20px;
  text-align: center;
  text-wrap: balance;
`
